import { Entry } from 'contentful';
import {
  Content,
  ContentType,
  RawContent,
  RawImageContent,
  RichContent,
  TextContent,
} from './types';

export const rawToContent = (entry: Entry<RawContent>): Content | null => {
  if (isRawImageContentEntry(entry)) {
    return {
      ...entry.fields,
      type: ContentType.IMAGE_CONTENT,
      image: entry.fields.image.fields.file.url,
    };
  } else if (isTextEntry(entry)) {
    return {
      ...entry.fields,
      type: ContentType.TEXT_CONTENT,
    };
  } else if (isRichContentEntry(entry)) {
    return {
      ...entry.fields,
      type: ContentType.RICH_CONTENT,
    };
  }

  return null;
};

const getContentType = (entry: Entry<RawContent>) => entry.sys.contentType.sys.id;

const isRawImageContentEntry = (entry: Entry<RawContent>): entry is Entry<RawImageContent> =>
  getContentType(entry) === ContentType.IMAGE_CONTENT;

const isRichContentEntry = (entry: Entry<RawContent>): entry is Entry<RichContent> =>
  getContentType(entry) === ContentType.RICH_CONTENT;

const isTextEntry = (entry: Entry<RawContent>): entry is Entry<TextContent> =>
  getContentType(entry) === ContentType.TEXT_CONTENT;
